module.exports = __webpack_public_path__ + "static/sprite_feather-icons-c24b35561118256dbf1061d43e9f5631.svg";